/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateOpportunitySchema } from './candidate-opportunity-schema';
import { opportunitySchema } from './opportunity-schema';
import { BusinessTitle, PositionReservedType, PositionRole, PositionWorksite, WeeklyTimeUnit } from "../enums";
export const positionSchema: z.AnyZodObject = z.object({
  aiDescription: z.string().nullish(),
  baselineBillRate: z.number().nullish(),
  baselineCost: z.number().nullish(),
  baselineMargin: z.number().nullish(),
  billingHoursPerDay: z.number().nullish(),
  billingUnitsPerWeek: z.number().nullish(),
  businessTitle: z.nativeEnum(BusinessTitle).nullish(),
  candidateOpportunities: 
    z.array(z.lazy(() => candidateOpportunitySchema))
  .nullish(),
  createdAt: z.string().datetime().nullish(),
  demandDriver: z.string().nullish(),
  description: z.string().nullish(),
  endDate: z.string().date().nullish(),
  endDateStatus: z.string().nullish(),
  id: z.string().uuid(),
  integrationId: z.string().nullish(),
  isPremium: z.boolean().nullish(),
  name: z.string().nullish(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  product: z.string().nullish(),
  reservedType: z.nativeEnum(PositionReservedType).nullish(),
  role: z.nativeEnum(PositionRole).nullish(),
  salesforceId: z.string().nullish(),
  startDate: z.string().date().nullish(),
  talentExperienceYears: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
  weeklyTimeUnit: z.nativeEnum(WeeklyTimeUnit).nullish(),
  worksite: z.nativeEnum(PositionWorksite).nullish(),
});

export type Position = z.infer<typeof positionSchema>;
